import { B as Wt, a as Nt, C as jt, D as Ft, L as St, M as Bt, R as Ht, T as Ut, V as $t } from "./TableOfContents-DSVIeNJH.mjs";
import { jsxs as g, jsx as s } from "react/jsx-runtime";
import { useRef as x, useImperativeHandle as T, useState as k, useEffect as L, createElement as C } from "react";
import a from "clsx";
import y from "animejs";
import v from "next/link";
import { useCurrentLocale as E } from "next-i18n-router/client";
import { i18nConfig as I } from "./lib.js";
import "./Content-DQidYhT2.mjs";
import { g as R } from "./getUrlWithLocale-Sb9sJa1R.mjs";
import "date-fns";
import "date-fns/locale";
import "next/headers";
import "./_baseToString-CcsvGzgN.mjs";
const b = "Input-module_inputWrapper__TYJbS", W = "Input-module_withIcon__ToU6Q", N = "Input-module_input__505b7", j = "Input-module_icon__qkecR", h = {
  inputWrapper: b,
  withIcon: W,
  input: N,
  icon: j
};
function F(t) {
  return /* @__PURE__ */ g("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    /* @__PURE__ */ s(
      "path",
      {
        d: "M11.059 18.118C14.9576 18.118 18.118 14.9576 18.118 11.059C18.118 7.16042 14.9576 4 11.059 4C7.16042 4 4 7.16042 4 11.059C4 14.9576 7.16042 18.118 11.059 18.118Z",
        stroke: "#1E1F1E",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ s("path", { d: "M20.0721 20.0718L16.1221 16.1218", stroke: "#1E1F1E", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function kt({ hasIcon: t = !1, className: r, placeholder: e, ...n }, i) {
  const o = x(null);
  return T(i, () => o.current), /* @__PURE__ */ g("div", { className: a(h.inputWrapper, t && h.withIcon), children: [
    /* @__PURE__ */ s("input", { ref: o, className: a(h.input, r), placeholder: e, ...n }),
    t && /* @__PURE__ */ s("span", { className: h.icon, children: /* @__PURE__ */ s(F, {}) })
  ] });
}
const S = "FormControl-module_wrapper__YTIL9", B = "FormControl-module_hasError__Esjds", H = "FormControl-module_error__fuU0f", U = "FormControl-module_hint__OYj42", $ = "FormControl-module_activeHint__wcVJK", q = "FormControl-module_title__TRovM", d = {
  wrapper: S,
  hasError: B,
  error: H,
  hint: U,
  activeHint: $,
  title: q
};
function Ct({ title: t, children: r, error: e, hint: n, htmlFor: i, activeHint: o, className: c }) {
  return /* @__PURE__ */ g("div", { className: a(d.wrapper, "text", !!e && d.hasError, c), children: [
    !!t && /* @__PURE__ */ s("label", { htmlFor: i, className: a(d.title, "h3"), children: t }),
    r,
    !!n && /* @__PURE__ */ s("div", { className: a(d.hint, o && d.activeHint, "text-sm"), children: n }),
    !!e && /* @__PURE__ */ s("div", { className: a(d.error, "text-sm"), children: e })
  ] });
}
function vt({
  className: t,
  enabled: r = !0,
  delay: e = 500,
  rotate: n = 0,
  text: i,
  white: o,
  purple: c,
  children: m
}) {
  const [_, f] = k(r), u = x(null);
  return L(() => {
    const l = setTimeout(() => {
      f((w) => w || r);
    }, e);
    return () => clearTimeout(l);
  }, [r, e]), L(() => {
    const l = u.current;
    if (l && _)
      return l.style.opacity = "0", y({
        targets: l,
        easing: "spring(1, 100, 10, 0)",
        scale: 1,
        opacity: 1,
        delay: e
      }), () => {
        y.remove(l);
      };
  }, [_, u, e, n]), /* @__PURE__ */ s(
    "span",
    {
      ref: u,
      style: {
        display: "inline-flex",
        opacity: 0,
        transformOrigin: "left",
        willChange: "opacity",
        transform: `rotate(${n}deg) scale(1.5)`
      },
      className: a(t, "stuffing", {
        "stuffing-white": o,
        "stuffing-purple": c,
        "stuffing-orange": !o && !c
      }),
      children: m || i
    }
  );
}
function Et({ href: t, locale: r, children: e, ...n }, i) {
  const o = x(null), c = E(I), m = r || c, _ = typeof t == "string" ? t : t ? `${t.pathname || ""}${t.query ? `?${new URLSearchParams(t.query).toString()}` : ""}` : "", f = _ ? R(_, m) : "";
  return T(i, () => o.current), /* @__PURE__ */ s(v, { href: f, locale: m, prefetch: !1, ...n, ref: o, children: e });
}
const J = "Text-module_text__XXjeA", M = "Text-module_xs__cPxPp", Y = "Text-module_sm__fl9vD", D = "Text-module_md__kiT9j", O = "Text-module_lg__nPLfy", P = "Text-module_left__mLCig", G = "Text-module_center__tNTJk", V = "Text-module_right__WlaBU", Z = "Text-module_overflow__mfOvl", A = "Text-module_lighter__Ac1E0", Q = "Text-module_normal__8e8-I", X = "Text-module_bold__ZRBJh", z = "Text-module_bolder__TDnBT", K = "Text-module_inherit__3m48G", tt = "Text-module_white__CcYJW", et = "Text-module_info__ABlmk", ot = "Text-module_dark__apstj", rt = "Text-module_darkLight__zci2U", nt = "Text-module_secondary__21S6G", st = "Text-module_secondaryLight__ZtnRi", it = "Text-module_warning__uRHSW", ct = "Text-module_error__efqQU", lt = "Text-module_primary__nfG7f", at = "Text-module_success__qYdpb", p = {
  text: J,
  xs: M,
  sm: Y,
  md: D,
  lg: O,
  left: P,
  center: G,
  right: V,
  overflow: Z,
  lighter: A,
  normal: Q,
  bold: X,
  bolder: z,
  inherit: K,
  white: tt,
  info: et,
  dark: ot,
  darkLight: rt,
  secondary: nt,
  secondaryLight: st,
  warning: it,
  error: ct,
  primary: lt,
  success: at
};
function It({ as: t = "p", children: r, overflow: e, className: n, weight: i = "normal", color: o, size: c = "md", textAlign: m, ..._ }, f) {
  const u = x(null);
  T(f, () => u.current);
  const l = a(
    p.text,
    p[c],
    p[i],
    e && p.overflow,
    m && p[m],
    o && p[o],
    n
  );
  return C(t, { className: l, ref: u, ..._ }, r);
}
export {
  Wt as Button,
  Nt as CloseBtn,
  jt as CopyLink,
  Ft as DataLayer,
  Ct as FormControl,
  Et as I18nLink,
  kt as Input,
  St as Loader,
  Bt as ModalWrapper,
  Ht as Row,
  vt as Stamp,
  Ut as TableOfContents,
  It as Text,
  $t as VideoEmbed
};
//# sourceMappingURL=components.js.map
